import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import { StepId } from 'webapp/services/wizard';

export default class WizardStartingRoute extends Route {
	@service('wizard') declare wizardService: Service.Wizard;
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		const selectedSource = this.wizardService.selectedSourceType;

		if (!selectedSource) {
			this.navigationService.transitionToRoute('wizard.source');
		}

		if (this.billingService.checkIfCan(BillingFeature.QB) && selectedSource?.isQbOnly) {
			this.navigationService.transitionToRoute('wizard.connect');
		}

		this.wizardService.activeStep = StepId.STARTING;
		this.wizardService.title = selectedSource?.isToken
			? 'Push your own data'
			: 'How to get started';
	}
}
